export default "__VITE_ASSET__DOWfvoW___"